(function () {
  var STORAGE_KEY = 'aw-favorites';

  var read = function () {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  };

  var write = function (items) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (error) {
    }
    document.dispatchEvent(new CustomEvent('aw:favorites-changed'));
  };

  var makeKey = function (type, handle) {
    return type + ':' + handle;
  };

  var isFavorite = function (type, handle) {
    var key = makeKey(type, handle);
    return read().some(function (item) {
      return makeKey(item.type, item.handle) === key;
    });
  };

  var addFavorite = function (data) {
    var items = read();
    var key = makeKey(data.type, data.handle);
    var exists = items.some(function (item) {
      return makeKey(item.type, item.handle) === key;
    });
    if (exists) return;
    items.unshift(data);
    write(items);
  };

  var removeFavorite = function (type, handle) {
    var key = makeKey(type, handle);
    write(read().filter(function (item) {
      return makeKey(item.type, item.handle) !== key;
    }));
  };

  var setButtonState = function (button, active) {
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
  };

  var handleClick = function (button, event) {
    event.preventDefault();
    event.stopPropagation();

    var type = button.dataset.favoriteType;
    var handle = button.dataset.favoriteHandle;
    if (!type || !handle) return;

    var nowActive = !button.classList.contains('is-active');
    if (nowActive) {
      addFavorite({
        type: type,
        handle: handle,
        url: button.dataset.favoriteUrl || '',
        title: button.dataset.favoriteTitle || '',
        image: button.dataset.favoriteImage || '',
        imageAlt: button.dataset.favoriteImageAlt || '',
        meta: button.dataset.favoriteMeta || ''
      });
    } else {
      removeFavorite(type, handle);
    }
    setButtonState(button, nowActive);
  };

  var initButton = function (button) {
    if (button.dataset.awFavoriteInitialized === 'true') return;
    button.dataset.awFavoriteInitialized = 'true';

    var type = button.dataset.favoriteType;
    var handle = button.dataset.favoriteHandle;
    if (type && handle) {
      setButtonState(button, isFavorite(type, handle));
    }

    button.addEventListener('click', function (event) {
      handleClick(button, event);
    });
  };

  var init = function (context) {
    Array.prototype.forEach.call((context || document).querySelectorAll('[data-aw-favorite-button]'), initButton);
  };

  window.awFavorites = {
    read: read,
    isFavorite: isFavorite,
    remove: removeFavorite,
    init: init
  };

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
